export default __webpack_public_path__ + "static/media/tanss.26da4279.svg";